import { FolderOpen, Pencil, Trash2, MoreVertical } from "lucide-react";
import defaultAvatar from "../../assets/logo/logo.png";
import { resolveMedia } from "../../services/api";
import { useState, useRef, useEffect } from "react";

export default function DriverRow({
  driver,
  onView,
  onEdit,
  onDelete,
  onToggleApprove,
  onAssignOrderType,
}) {
  const user = driver.user;
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const avatar = resolveMedia(user?.profilPicture, defaultAvatar);

  const approved = driver.isApproved === true;
  return (
    <tr>
      {/* CHAUFFEUR */}
      <td>
        <div className="userCell">
          <img src={avatar} alt="avatar" className="tableAvatar" />
          <div>
            <div className="userName">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="userSub">{user?.contact?.tel || "-"}</div>
          </div>
        </div>
      </td>

      {/* TELEPHONE */}
      {/* <td>{user?.contact?.tel || "-"}</td> */}

      {/* SOLDE */}
      <td>
        <span className="roleBadge">
          {(driver?.balance ?? 0).toLocaleString()} CFA
        </span>
      </td>

      {/* STATUT */}
      <td className="center">
        <Switch checked={approved} onChange={() => onToggleApprove(driver)} />
      </td>
      {/* DISPONIBILITE */}
      <td className="center">
        <span
          className={`statusDot ${driver.isAvailable === true ? "active" : "inactive"}`}
          title={driver.isAvailable === true ? "Disponible" : "Indisponible"}
        />
      </td>

      <td className="center">
        <div className="actionsMenu" ref={menuRef}>
          <button className="iconBtn" onClick={() => setOpen(!open)}>
            <MoreVertical size={18} />
          </button>

          {open && (
            <div className="dropdownActions">
              <button onClick={() => onView?.(driver)}>
                <FolderOpen size={16} /> Détails
              </button>

              <button onClick={() => onEdit?.(driver)}>
                <Pencil size={16} /> Modifier
              </button>

              <button className="danger" onClick={() => onDelete?.(driver)}>
                <Trash2 size={16} /> Supprimer
              </button>

              <button
                type="button"
                className="iconBtn"
                title="Types de commandes"
                onClick={() => onAssignOrderType?.(driver)}>
                Types de commandes
              </button>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}
function Switch({ checked, onChange }) {
  return (
    <label className="switch">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="slider" />
    </label>
  );
}
